module.exports = __webpack_public_path__ + "static/img/eye-on.d37bbb52.svg";